import { CardContent, Typography } from '@mui/material';
import { useTranslate } from 'react-admin';

export const DatagridNoResults: React.FC = () => {
  const translate = useTranslate();

  return (
    <CardContent>
      <Typography variant="body2">{translate('ra.navigation.no_results')}</Typography>
    </CardContent>
  );
};
